import { useMemo } from "react";

const useCheckQuestionsMinLength = (questions = []) =>
	useMemo(() => {
		return (
			questions.length &&
			questions.filter(Boolean).every((question) => {
				if (!question) {
					return false;
				}
				if (question.title || question.text) {
					if (question.answerType === "text" || question.type?.id === 3) {
						return true;
					} else {
						const countAnswers = question.answers?.filter(Boolean).length;
						if (!countAnswers) {
							return false;
						}
						if (!question.haveOtherOption && countAnswers < 2) {
							return false;
						}

						return question.answers?.filter(Boolean).every((answer) => {
							if (answer.text?.length || answer.name?.length) {
								return true;
							}
						});
					}
				}
			})
		);
	}, [questions]);

export default useCheckQuestionsMinLength;
